import Axios from 'axios'

import {
    XsrfResilient,
} from '@/services/Helpers'

import {
    standardizeOrderComplete,
    MUTATIVELY_appendArrivalInformationToOrderCartAfterStandardizing,
} from '@/services/Standardizers'

import {generateLineItemsFromCheckout} from './index'

// get completed order (Order Confirmation)
export const getCompletedOrder = XsrfResilient(async ({ orderId, orderDate }) => {
    if (!orderId) {
        return false
    }
    // Returns Order data. - https://developer.bigcommerce.com/api-reference/storefront/orders/order/ordersbyorderidget
    // This will return order data immediately after an order is placed on the storefront.
    const order = (await Axios.get(`/api/storefront/orders/${orderId}`)).data
    const lineItems = await generateLineItemsFromCheckout(order)
    const newOrder = standardizeOrderComplete(order, lineItems, orderDate)
    await MUTATIVELY_appendArrivalInformationToOrderCartAfterStandardizing({ order: newOrder })
    return newOrder
})